const setBorder = (ctx, type, strokeWidth) => {
  ctx.lineWidth = strokeWidth;
  switch (type) {
    case "solid":
      ctx.lineCap = "butt";
      break;
    case "dashed":
      ctx.lineCap = "butt";
      ctx.setLineDash([Math.min(5 * window.devicePixelRatio, strokeWidth * 3)]);
      break;
    case "dotted":
      ctx.lineCap = "round";
      ctx.setLineDash([1, strokeWidth * 2 - 1]);
      break;
    case "none":
      ctx.strokeStyle = "transparent";
  }
};

export { setBorder };
//# sourceMappingURL=setBorder.js.map
